module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('a', {
    attrs: {
      "id": "p9000f1639970005001"
    }
  }), _c('h2', {
    staticClass: "chapter-title"
  }, [_c('strong', [_vm._v("contents")])]), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  })]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-term"
  }, [_c('a', {
    attrs: {
      "href": "#/ch005#p9000f1639970007001"
    }
  }, [_c('strong', [_vm._v("beautify your home!")])])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-term"
  }, [_c('a', {
    attrs: {
      "href": "#/ch006#p9000f1639970008001"
    }
  }, [_c('strong', [_vm._v("in the beginning…")])])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-aahead-title"
  }, [_c('a', {
    attrs: {
      "href": "#/ch006#p9000f1639970009001"
    }
  }, [_vm._v("fibres ")]), _c('a', {
    attrs: {
      "href": "#/ch006#p9000f1639970009001"
    }
  }, [_vm._v(" 9")])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-aahead-title"
  }, [_c('a', {
    attrs: {
      "href": "#/ch006#p9000f1639970010001"
    }
  }, [_vm._v("weight ")]), _c('a', {
    attrs: {
      "href": "#/ch006#p9000f1639970010001"
    }
  }, [_vm._v(" 10")])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-aahead-title"
  }, [_c('a', {
    attrs: {
      "href": "#/ch006#p9000f1639970011001"
    }
  }, [_vm._v("colour ")]), _c('a', {
    attrs: {
      "href": "#/ch006#p9000f1639970011001"
    }
  }, [_vm._v(" 11")])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-aahead-title"
  }, [_c('a', {
    attrs: {
      "href": "#/ch006#p9000f1639970012001"
    }
  }, [_vm._v("texture ")]), _c('a', {
    attrs: {
      "href": "#/ch006#p9000f1639970012001"
    }
  }, [_vm._v(" 12")])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-aahead-title"
  }, [_c('a', {
    attrs: {
      "href": "#/ch006#p9000f1639970014001"
    }
  }, [_vm._v("needles ")]), _c('a', {
    attrs: {
      "href": "#/ch006#p9000f1639970014001"
    }
  }, [_vm._v(" 14")])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-aahead-title"
  }, [_c('a', {
    attrs: {
      "href": "#/ch006#p9000f1639970015001"
    }
  }, [_vm._v("gauge ")]), _c('a', {
    attrs: {
      "href": "#/ch006#p9000f1639970015001"
    }
  }, [_vm._v(" 15")])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-aahead-title"
  }, [_c('a', {
    attrs: {
      "href": "#/ch006#p9000f1639970016001"
    }
  }, [_vm._v("abbreviations ")]), _c('a', {
    attrs: {
      "href": "#/ch006#p9000f1639970016001"
    }
  }, [_vm._v(" 16")])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-aahead-title"
  }, [_c('a', {
    attrs: {
      "href": "#/ch006#p9000f1639970017001"
    }
  }, [_vm._v("reading knitting patterns ")]), _c('a', {
    attrs: {
      "href": "#/ch006#p9000f1639970017001"
    }
  }, [_vm._v(" 17")])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-term"
  }, [_c('span', {
    attrs: {
      "href": "#/ch007#p9000f1639970019001",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("and now to knit…")])])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-aahead-title"
  }, [_c('span', {
    attrs: {
      "href": "#/ch007#p9000f1639970020001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("on the fringes ")]), _c('span', {
    attrs: {
      "href": "#/ch007#p9000f1639970020001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 20")])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-aahead-title"
  }, [_c('span', {
    attrs: {
      "href": "#/ch007#p9000f1639970024001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("spring greens ")]), _c('span', {
    attrs: {
      "href": "#/ch007#p9000f1639970024001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 24")])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-ahead-title"
  }, [_c('span', {
    attrs: {
      "href": "#/ch007#p9000f1639970026001",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("shake your tail feather")])])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-ahead-title"
  }, [_c('span', {
    attrs: {
      "href": "#/ch007#p9000f1639970026002",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("sequins and spangles")])])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-ahead-title"
  }, [_c('span', {
    attrs: {
      "href": "#/ch007#p9000f1639970026003",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("pompom parade")])])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-ahead-title"
  }, [_c('span', {
    attrs: {
      "href": "#/ch007#p9000f1639970027001",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("floral fantasy")])])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-aahead-title"
  }, [_c('span', {
    attrs: {
      "href": "#/ch007#p9000f1639970030001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("terrific trimmings ")]), _c('span', {
    attrs: {
      "href": "#/ch007#p9000f1639970030001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 30")])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-ahead-title"
  }, [_c('span', {
    attrs: {
      "href": "#/ch007#p9000f1639970032001",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("sequinned shimmer")])])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-ahead-title"
  }, [_c('span', {
    attrs: {
      "href": "#/ch007#p9000f1639970034001",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("bead me up!")])])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-aahead-title"
  }, [_c('span', {
    attrs: {
      "href": "#/ch007#p9000f1639970036001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("celtic knot garden ")]), _c('span', {
    attrs: {
      "href": "#/ch007#p9000f1639970036001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 36")])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-aahead-title"
  }, [_c('span', {
    attrs: {
      "href": "#/ch007#p9000f1639970040001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("sizzling stripes ")]), _c('span', {
    attrs: {
      "href": "#/ch007#p9000f1639970040001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 40")])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-ahead-title"
  }, [_c('span', {
    attrs: {
      "href": "#/ch007#p9000f1639970042001",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("brilliant bolster")])])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-ahead-title"
  }, [_c('span', {
    attrs: {
      "href": "#/ch007#p9000f1639970043001",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("purple patch")])])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-aahead-title"
  }, [_c('span', {
    attrs: {
      "href": "#/ch007#p9000f1639970044001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("mixing it up ")]), _c('span', {
    attrs: {
      "href": "#/ch007#p9000f1639970044001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 44")])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-ahead-title"
  }, [_c('span', {
    attrs: {
      "href": "#/ch007#p9000f1639970046001",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("mixed messages")])])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-ahead-title"
  }, [_c('span', {
    attrs: {
      "href": "#/ch007#p9000f1639970048001",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("colour carnival")])])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-aahead-title"
  }, [_c('span', {
    attrs: {
      "href": "#/ch007#p9000f1639970050001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("patchwork pieces ")]), _c('span', {
    attrs: {
      "href": "#/ch007#p9000f1639970050001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 50")])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-ahead-title"
  }, [_c('span', {
    attrs: {
      "href": "#/ch007#p9000f1639970052001",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("hedgerow harlequin")])])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-ahead-title"
  }, [_c('span', {
    attrs: {
      "href": "#/ch007#p9000f1639970054001",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("springtime shades")])])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-aahead-title"
  }, [_c('span', {
    attrs: {
      "href": "#/ch007#p9000f1639970056001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("cubist colours ")]), _c('span', {
    attrs: {
      "href": "#/ch007#p9000f1639970056001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 56")])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-ahead-title"
  }, [_c('span', {
    attrs: {
      "href": "#/ch007#p9000f1639970058001",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("citrus squares")])])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-ahead-title"
  }, [_c('span', {
    attrs: {
      "href": "#/ch007#p9000f1639970060001",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("black and white blocks")])])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-aahead-title"
  }, [_c('span', {
    attrs: {
      "href": "#/ch007#p9000f1639970062001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("life’s a beach ")]), _c('span', {
    attrs: {
      "href": "#/ch007#p9000f1639970062001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 62")])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-ahead-title"
  }, [_c('span', {
    attrs: {
      "href": "#/ch007#p9000f1639970064001",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("breaking waves")])])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-ahead-title"
  }, [_c('span', {
    attrs: {
      "href": "#/ch007#p9000f1639970065001",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("surf’s up")])])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-aahead-title"
  }, [_c('span', {
    attrs: {
      "href": "#/ch007#p9000f1639970066001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("rustic entrelac ")]), _c('span', {
    attrs: {
      "href": "#/ch007#p9000f1639970066001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 66")])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-aahead-title"
  }, [_c('span', {
    attrs: {
      "href": "#/ch007#p9000f1639970074001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("french fancies ")]), _c('span', {
    attrs: {
      "href": "#/ch007#p9000f1639970074001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 74")])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-ahead-title"
  }, [_c('span', {
    attrs: {
      "href": "#/ch007#p9000f1639970078001",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("taking the floor")])])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-ahead-title"
  }, [_c('span', {
    attrs: {
      "href": "#/ch007#p9000f1639970079001",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("flower power")])])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-aahead-title"
  }, [_c('span', {
    attrs: {
      "href": "#/ch007#p9000f1639970080001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("denim delight ")]), _c('span', {
    attrs: {
      "href": "#/ch007#p9000f1639970080001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 80")])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-aahead-title"
  }, [_c('span', {
    attrs: {
      "href": "#/ch007#p9000f1639970086001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("romantic roses ")]), _c('span', {
    attrs: {
      "href": "#/ch007#p9000f1639970086001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 86")])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-ahead-title"
  }, [_c('span', {
    attrs: {
      "href": "#/ch007#p9000f1639970088001",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("rose garden")])])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-ahead-title"
  }, [_c('span', {
    attrs: {
      "href": "#/ch007#p9000f1639970090001",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("posy pillowcase")])])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-aahead-title"
  }, [_c('span', {
    attrs: {
      "href": "#/ch007#p9000f1639970094001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("wobbly stripe seat ")]), _c('span', {
    attrs: {
      "href": "#/ch007#p9000f1639970094001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 92")])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-aahead-title"
  }, [_c('span', {
    attrs: {
      "href": "#/ch007#p9000f1639970096001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("making waves ")]), _c('span', {
    attrs: {
      "href": "#/ch007#p9000f1639970096001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 96")])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-ahead-title"
  }, [_c('span', {
    attrs: {
      "href": "#/ch007#p9000f1639970098001",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("rippling waves")])])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-ahead-title"
  }, [_c('span', {
    attrs: {
      "href": "#/ch007#p9000f1639970100001",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("wavy wall panel")])])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-term"
  }, [_c('span', {
    attrs: {
      "href": "#/ch008#p9000f1639970102001",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("it’s all in the detail…")])])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-aahead-title"
  }, [_c('span', {
    attrs: {
      "href": "#/ch008#p9000f1639970103001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("casting on ")]), _c('span', {
    attrs: {
      "href": "#/ch008#p9000f1639970103001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 103")])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-aahead-title"
  }, [_c('span', {
    attrs: {
      "href": "#/ch008#p9000f1639970104001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("knit stitch ")]), _c('span', {
    attrs: {
      "href": "#/ch008#p9000f1639970104001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 104")])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-aahead-title"
  }, [_c('span', {
    attrs: {
      "href": "#/ch008#p9000f1639970105001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("purl stitch ")]), _c('span', {
    attrs: {
      "href": "#/ch008#p9000f1639970105001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 105")])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-aahead-title"
  }, [_c('span', {
    attrs: {
      "href": "#/ch008#p9000f1639970106001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("binding off ")]), _c('span', {
    attrs: {
      "href": "#/ch008#p9000f1639970106001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 106")])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-aahead-title"
  }, [_c('span', {
    attrs: {
      "href": "#/ch008#p9000f1639970107001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("beads and loops ")]), _c('span', {
    attrs: {
      "href": "#/ch008#p9000f1639970107001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 107")])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-aahead-title"
  }, [_c('span', {
    attrs: {
      "href": "#/ch008#p9000f1639970108001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("increasing stitches ")]), _c('span', {
    attrs: {
      "href": "#/ch008#p9000f1639970108001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 108")])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-aahead-title"
  }, [_c('span', {
    attrs: {
      "href": "#/ch008#p9000f1639970109001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("decreasing stitches ")]), _c('span', {
    attrs: {
      "href": "#/ch008#p9000f1639970109001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 109")])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-aahead-title"
  }, [_c('span', {
    attrs: {
      "href": "#/ch008#p9000f1639970110001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("knitting in the round ")]), _c('span', {
    attrs: {
      "href": "#/ch008#p9000f1639970110001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 110")])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-aahead-title"
  }, [_c('span', {
    attrs: {
      "href": "#/ch008#p9000f1639970111001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("cables ")]), _c('span', {
    attrs: {
      "href": "#/ch008#p9000f1639970111001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 111")])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-aahead-title"
  }, [_c('span', {
    attrs: {
      "href": "#/ch008#p9000f1639970112001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("intarsia ")]), _c('span', {
    attrs: {
      "href": "#/ch008#p9000f1639970112001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 112")])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-aahead-title"
  }, [_c('span', {
    attrs: {
      "href": "#/ch008#p9000f1639970114001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("embellishments ")]), _c('span', {
    attrs: {
      "href": "#/ch008#p9000f1639970114001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 114")])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-aahead-title"
  }, [_c('span', {
    attrs: {
      "href": "#/ch008#p9000f1639970115001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("flowers and leaves ")]), _c('span', {
    attrs: {
      "href": "#/ch008#p9000f1639970115001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 115")])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-aahead-title"
  }, [_c('span', {
    attrs: {
      "href": "#/ch008#p9000f1639970116001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("finishing techniques ")]), _c('span', {
    attrs: {
      "href": "#/ch008#p9000f1639970116001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 116")])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-aahead-title"
  }, [_c('span', {
    attrs: {
      "href": "#/ch008#p9000f1639970118001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("cushions ")]), _c('span', {
    attrs: {
      "href": "#/ch008#p9000f1639970118001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 118")])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-aahead-title"
  }, [_c('span', {
    attrs: {
      "href": "#/ch008#p9000f1639970120001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("fulling ")]), _c('span', {
    attrs: {
      "href": "#/ch008#p9000f1639970120001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 120")])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-aahead-title"
  }, [_c('span', {
    attrs: {
      "href": "#/ch008#p9000f1639970121001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("troubleshooting ")]), _c('span', {
    attrs: {
      "href": "#/ch008#p9000f1639970121001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 121")])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-aahead-title"
  }, [_c('span', {
    attrs: {
      "href": "#/ch008#p9000f1639970123001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("aftercare ")]), _c('span', {
    attrs: {
      "href": "#/ch008#p9000f1639970123001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 123")])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-aahead-title"
  }, [_c('span', {
    attrs: {
      "href": "#/ch008#p9000f1639970124001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("yarns used ")]), _c('span', {
    attrs: {
      "href": "#/ch008#p9000f1639970124001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 124")])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-aahead-title"
  }, [_c('span', {
    attrs: {
      "href": "#/ch008#p9000f1639970127001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("suppliers ")]), _c('span', {
    attrs: {
      "href": "#/ch008#p9000f1639970127001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 127")])])])]), _c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  })]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-term"
  }, [_c('span', {
    attrs: {
      "href": "#/ch009#p9000f1639970128001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("about the author ")]), _c('span', {
    attrs: {
      "href": "#/ch009#p9000f1639970128001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 128")])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-term"
  }, [_c('span', {
    attrs: {
      "href": "#/ch010#p9000f1639970128002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("acknowledgments")])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-term"
  }, [_c('span', {
    attrs: {
      "href": "#/ch011#p9000f1639970128003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("index")])])])])])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('a', {
    attrs: {
      "id": "p9000f1639960006001"
    }
  }), _c('div', {
    staticClass: "media-group"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p9000f163g6001.png",
      "width": "90.38113%"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-87678930","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ch004.vue
// module id = 69
// module chunks = 0